(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-text-premium"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Apparition au défilement */
    var sections = document.querySelectorAll('.itp2--reveal');
    if (sections.length && 'IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      sections.forEach(function (el) { io.observe(el); });
    } else {
      sections.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* Léger basculement du cadre au survol, souris uniquement */
    if (!window.matchMedia('(hover: hover)').matches || reduce) return;
    document.querySelectorAll('[data-itp-tilt]').forEach(function (el) {
      var frame = el.querySelector('.itp2__frame');
      if (!frame) return;
      var raf = null;
      el.addEventListener('pointermove', function (ev) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var r = el.getBoundingClientRect();
          var px = (ev.clientX - r.left) / r.width - 0.5;
          var py = (ev.clientY - r.top) / r.height - 0.5;
          frame.style.transform =
            'rotateY(' + (px * 5).toFixed(2) + 'deg) rotateX(' + (-py * 5).toFixed(2) + 'deg)';
        });
      });
      el.addEventListener('pointerleave', function () { frame.style.transform = ''; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["philidor-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var canHover = window.matchMedia('(hover: hover)').matches;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!canHover || reduce) return;

    function bind(el, max) {
      var frame = null;
      el.addEventListener('pointermove', function (e) {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          var r = el.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          el.style.transform =
            'rotateY(' + (px * max).toFixed(2) + 'deg) rotateX(' + (-py * max).toFixed(2) + 'deg) translateZ(0)';
        });
      });
      el.addEventListener('pointerleave', function () {
        el.style.transform = '';
      });
    }

    document.querySelectorAll('[data-tilt]').forEach(function (el) { bind(el, 9); });
    document.querySelectorAll('[data-tilt-soft]').forEach(function (el) { bind(el, 3); });
  })();

  } catch(e) { console.error(e); }
})();
})();
